<template>
  <div>
    <div class="section-title">
      Paso 4. Forma de pago
    </div>
    <div class="section-summary">
      Elige la forma de pago. Recuerda que todas las comisiones son externas a Flagship.mx y son únicamente resultantes del método de pago que se utilice.
    </div>
    <div class="section-content">
      <div class="section-column">
        <div class="card" :class="{ 'card-selected': selected === 1 }" @click="selected = 1; setPaymentMethod('card')">
          <img class="card-logo" src="/card.svg">
          <div class="card-title">Tarjetas Visa y MasterCard</div>
          <div class="card-subtitle">2.95% + IVA</div>
        </div>
      </div>
      <div class="section-column">
        <div class="card" :class="{ 'card-selected': selected === 2 }" @click="selected = 2; setPaymentMethod('spei')">
          <img class="card-logo" src="/spei.svg">
          <div class="card-title">Transferencia Interbancaria</div>
          <div class="card-subtitle">1% + IVA</div>
        </div>
      </div>
    </div>
    <div class="section-button">
      <div v-if="selected === 1" class="button" @click="() => {$emit('next');}">Siguiente</div>
      <div v-if="selected === 2" class="button" @click="() => {$emit('next'); $emit('next');}">Siguiente</div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapMutations, mapState } = createNamespacedHelpers('investment');

export default {
  data() {
    return {
      selected: 0,
    };
  },
  computed: {
    cardPricing() {
      return ((this.totalInvestment * 0.029) + 7.5).toFixed(2);
    },
    speiPricing() {
      return 8;
    },
    ...mapState([
      'totalInvestment',
    ]),
  },
  methods: {
    ...mapMutations([
      'setPaymentMethod',
    ]),
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.card {
  margin-top: 20px;
  border: 1px solid #DCDEDD;
  padding: 25px;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 20px;
}
.card-logo {
  height: 45px;
  width: auto;
}
.card-title {
  font-size: 18px;
  margin-top: 16px;
  color: #d8d8d8;
}
.card-subtitle {
  color: #d8d8d8;
  font-size: 24px;
  margin-top: 16px;
}
.card-selected {
  border: 2px solid #2c70c1;
  padding: 24px;
  .card-title {
    color: #2c70c1;
  }
  .card-subtitle {
    color: #2c70c1;
  }
}
</style>
